import { Navigate } from "react-router-dom";
import { useAuth } from "hooks/useAuth";

export const ProtectedRoute = ({ children }) => {
  const { user, currentApp } = useAuth();

  function isEmpty(val) {
    return (val === undefined || val == null || val.length <= 0) ? true : false;
  }

  if (isEmpty(user)) {
    let params = "";

    if (!isEmpty(currentApp)) {
      if (!isEmpty(currentApp.tenantId)) {
        params = `/${currentApp.tenantId}`
      }

      if (!isEmpty(currentApp.appId)) {
        params += `/${currentApp.appId}`
      }
    }

    return <Navigate to={`/authentication/sign-in${params}`} />;
  }

  return children;
};